import { fun_PostAction } from "@/api";
export default {
  data: () => {
    return {
      // 图表实例
      chart: null,
      // 图表配置
      option: {}
    };
  },
  // 模板编译完成
  mounted() {
    // 获取待办和已办数量
    this.fun_GetProjectCount();
  },
  // 模板销毁之前
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    // 销毁图表实例
    this.chart.dispose();
    // 清空图表实例
    this.chart = null;
  },
  // 自定义方法
  methods: {
    /**
     * 水球图
     * @author 滕威
     */
    fun_InitCharts(i, j) {
      // 绑定到实例
      let el = this.$el;
      // 延迟执行方法
      this.$nextTick(() => {
        // 初始化
        this.chart = this.$echarts.init(el);
        // 获取配置
        const option = this.fun_GetOption(i, j);
        // 设置图表配置
        this.chart.setOption(option);
      });
      // 监听图表，防止溢出父元素
      window.addEventListener("resize", () => {
        this.chart.resize();
      });
    },

    /**
     * 获取代办事项数和已办事项数
     * @author zhouzhou
     */
    async fun_GetProjectCount() {
      // 请求，获取结果集
      let res = await fun_PostAction("/projectProcess/getProjectCount", null);
      // 解构res.data
      const { data } = res.data;
      // 代办
      var toDo;
      // 已办
      var haveDone;
      // 循环
      data.forEach(e => {
        // 判断是待办还是已办
        if (e.state === "0") {
          toDo = e.count;
        } else {
          haveDone = e.count;
        }
      });
      this.fun_InitCharts(toDo, haveDone);
    },

    /**
     * @description 配置
     * @author 滕威
     */
    fun_GetOption(i, j) {
      return {
        tooltip: {
          trigger: "item"
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "60%",
            selectedMode: "single",
            selectedOffset: 6,
            data: [
              {
                value: j,
                name: "已办理事项",
                label: {
                  formatter: "{name|{b}}\n{value|{c}}",
                  rich: {
                    name: {
                      color: "#42C893",
                      lineHeight: 22,
                      fontSize: 14
                    },
                    value: {
                      color: "#42C893",
                      fontSize: 24
                    }
                  }
                },
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#97FFE1" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#39D28F" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                }
              },
              {
                value: i,
                name: "待办事项",
                label: {
                  formatter: "{name|{b}}\n{value|{c}}",
                  rich: {
                    name: {
                      color: "#EBBE2B",
                      lineHeight: 22,
                      fontSize: 14
                    },
                    value: {
                      color: "#EBBE2B",
                      fontSize: 24
                    }
                  }
                },
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#DEA60F" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#FFE457" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                }
              }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          },
          {
            name: "外边框",
            type: "pie",
            clockWise: false, // 顺时加载
            hoverAnimation: false, // 鼠标移入变大
            center: ["50%", "50%"],
            radius: ["68%", "68%"],
            label: {
              show: false
              // normal: {
              // }
            },
            data: [
              {
                value: 9,
                tooltip: {
                  show: false
                },
                name: "",
                itemStyle: {
                  borderWidth: 1,
                  borderColor: "#85E3C0"
                  // normal: {
                  // }
                }
              }
            ]
          }
        ]
      };
    }
  }
};
